module.exports = __webpack_public_path__ + "img/logo.85aba9f1.png";